import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/About.vue')
    },
    // {
    //   path: '/directory',
    //   name: 'directory',
    //   component: () => import('@/views/Directory.vue')
    // },
    {
      path: '/clips/:channelName?',
      name: 'clipsearch',
      component: () => import('@/views/Clips.vue')
    },
    {
      path: '/vods/:channelName?',
      name: 'videosearch',
      component: () => import('@/views/Video.vue')
    },
    {
      path: '/teams/:team?',
      name: 'teams',
      component: () => import('@/views/Teams.vue')
    },
    {
      path: '/channel/:channelName',
      name: 'channel',
      component: () => import('@/views/Channel.vue')
    },
    {
      path: '/generateteams',
      name: 'generateteams',
      component: () => import('@/views/GenerateTeams.vue')
    },
    {
      path: '/markers',
      name: 'markers',
      component: () => import('@/views/Markers.vue')
    },
    {
      path: '/listexport',
      name: 'listexport',
      component: () => import('@/views/ListExport.vue')
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('@/views/auth.vue')
    },
  ]
})
